import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as ParcelActions from '../_actions/parcel';
import { Parcel } from '../_models';

export interface ParcelState extends EntityState<Parcel> {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<Parcel> = createEntityAdapter<Parcel>();

const initialState: ParcelState = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

const parcelReducer = createReducer(
  initialState,

  on(ParcelActions.loadParcels, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(ParcelActions.loadParcelsSuccess, (state, { parcels }) =>
    adapter.setAll(parcels, { ...state, loaded: true, loading: false })
  ),

  on(ParcelActions.loadParcelsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ParcelActions.addParcelSuccess, (state, { parcel }) => adapter.addOne(parcel, state)),

  on(ParcelActions.updateParcelSuccess, (state, { parcel }) => adapter.upsertOne(parcel, state)),

  on(ParcelActions.deleteParcelSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    ParcelActions.addParcelFailure,
    ParcelActions.updateParcelFailure,
    ParcelActions.deleteParcelFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: ParcelState | undefined, action: Action) {
  return parcelReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
